import gql from "graphql-tag";

export const NOTIFY_ME_CREATE = gql`
  mutation notifyMeCreate($variantId: ID!) {
    notifyMeCreate(variantId: $variantId) {
      notifyme {
        id
        createdAt
        notifiedAt
      }
    }
  }
`;

export const ME_FOR_NOTIFY_ME = gql`
  query meForNotifyMe {
    me {
      id
      mobileNumber
      mobileVerified
    }
  }
`;
